import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CURRICULUM } from '../data/content';
import { ChevronDown } from 'lucide-react';

export default function Curriculum() {
  const [open, setOpen] = useState(0);

  return (
    <section id="curriculum" className="py-24 md:py-32">
      <div className="container-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="sticky top-32">
            <div className="section-label">{CURRICULUM.eyebrow}</div>
            <h2 className="font-display text-[42px] md:text-[54px] leading-[1.02] mt-5">
              {CURRICULUM.title}
              <br />
              <span className="grad-text-red">{CURRICULUM.titleAccent}</span>
            </h2>
            <p className="mt-6 text-[16px] text-[color:var(--muted)] leading-relaxed max-w-sm">{CURRICULUM.intro}</p>
            <div className="mt-10 flex gap-10">
              <div>
                <div className="font-display text-[42px] leading-none text-[color:var(--ink)]">10</div>
                <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[color:var(--muted)] mt-2">
                  Phases
                </div>
              </div>
              <div>
                <div className="font-display text-[42px] leading-none text-[color:var(--ink)]">5</div>
                <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[color:var(--muted)] mt-2">
                  Months
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-[color:var(--line)] border-t border-b border-line">
            {CURRICULUM.phases.map((p, i) => {
              const isOpen = open === i;
              return (
                <div key={p.title}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between py-6 text-left group"
                  >
                    <div className="flex items-center gap-6">
                      <span className="font-display text-[18px] text-[color:var(--muted)] w-8">
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      <span className="font-display text-[22px] md:text-[26px] text-[color:var(--ink)] group-hover:text-red transition-colors">
                        {p.title}
                      </span>
                    </div>
                    <motion.span animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.25 }}>
                      <ChevronDown size={22} className="text-[color:var(--muted)]" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="overflow-hidden"
                      >
                        <div className="pb-6 pl-14 grid sm:grid-cols-2 gap-x-8 gap-y-2">
                          {p.topics.map((t) => (
                            <div key={t} className="flex items-start gap-2 text-[14.5px] text-[color:var(--ink)]">
                              <span className="mt-2 w-1.5 h-1.5 rounded-full bg-red flex-shrink-0" />
                              <span>{t}</span>
                            </div>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
